import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';

const mockOrders = [
  {
    _id: 'o1',
    name: 'Jane Brown',
    number: '8765551234',
    meat: [{ _id: 'm3', name: 'Stew Chicken' }],
    rice: { _id: 'r1', name: 'Rice and Peas' },
    veg: { _id: 'v1', name: 'Steam Veg' },
    side: [],
    special: null,
    size: 'Large',
    cost: 700,
    received: 700,
    note: 'Extra gravy',
    change: ''
  },
  {
    _id: 'o2',
    name: 'Marcus Green',
    number: '8765557890',
    meat: [{ _id: 'm7', name: 'Curry Goat' }],
    rice: { _id: 'r3', name: 'White Rice' },
    veg: { _id: 'v2', name: 'Raw Veg' },
    side: [{ _id: 'sd2', name: 'Dumpling' }],
    special: null,
    size: 'Large',
    cost: 700,
    received: 1000,
    note: '',
    change: ''
  },
  {
    _id: 'o3',
    name: 'Shanice Powell',
    number: '8765552468',
    meat: [{ _id: 'm2', name: 'Escovietch Chicken' }, { _id: 'm5', name: 'Stew Beef' }],
    rice: { _id: 'r2', name: 'Veg Rice' },
    veg: { _id: 'v1', name: 'Steam Veg' },
    side: [],
    special: null,
    size: 'Large',
    cost: 700,
    received: 0,
    note: 'Mix — half and half',
    change: ''
  }
];

export default class AdminOrdersTable extends Component {
  state = {
    orders: mockOrders,
    path: this.props.path || 'daily'
  }

  render() {
    const handleOnSave = (oldValue, newValue, row) => {
      const orders = this.state.orders.map(o => o._id === row._id ? { ...o, received: Number(newValue) } : o);
      this.setState({ orders });
    }

    const orderFormatter = (cell, row) => {
      return [
        row.special ? row.special.name : undefined,
        row.meat ? `${row.meat.map(m => m.name).join(", ")} ${row.meat.length > 1 ? "(Mix)": ""}(${row.size})`: undefined,
        row.rice ? row.rice.name : undefined,
        row.veg ? row.veg.name : undefined,
        row.side ? row.side.map(s => s.name) : undefined
      ]
        .reduce((prev, cur) => prev.concat(cur), [])
        .filter(f => f)
        .join(", ")
      + (row.note ? ` (${row.note})` : '')
    }

    const changeFormatter = (cell, row) => {
      return row.received - row.cost;
    }

    const columns = [
      { dataField: '_id', text: 'ID', hidden: true },
      { dataField: 'name', text: 'Customer', editable: false },
      { dataField: 'number', text: 'Number', editable: false },
      { dataField: 'meat', text: 'Order', formatter: orderFormatter, editable: false },
      { dataField: 'cost', text: 'Cost', editable: false },
      { dataField: 'received', text: 'Collected' },
      { dataField: 'change', text: 'Change', formatter: changeFormatter, editable: false }
    ];

    return (
      <div>
        <div>
          {this.state.orders[0] &&
            <span style={{float: 'right', marginTop: '20px'}}>
              Collected:
                <span style={{fontWeight: '700'}}> {this.state.orders.map(o => o.received).reduce((prev, cur) => prev+cur)}</span> |
              Total:
              <span style={{fontWeight: '700'}}> {this.state.orders.map(o => o.cost).reduce((prev, cur) => prev+cur)}</span>
            </span>}
          <h1>Di awda dem</h1>
          <BootstrapTable
            keyField='_id'
            data={ this.state.orders }
            columns={ columns }
            cellEdit={ cellEditFactory({
              mode: 'dbclick',
              blurToSave: true,
              afterSaveCell: handleOnSave,
              autoSelectText: true
            }) }
            noDataIndication="None yet"
            bordered={ false }
            striped
            hover
            condensed
          />
        </div>
      </div>
    )
  }
}
